import React from 'react';
import { inject } from 'mobx-react';
import { VirtualSKUStepTemplate } from 'themes/modules/product/wizard/pages';

@inject(i => ({
	productEditViewStore: i.rootStore.productEditViewStore,
}))
class VirtualSKUStep extends React.Component {
	render() {
		return <VirtualSKUStepTemplate {...this.props} />;
	}
}

export default VirtualSKUStep;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/VirtualSKUStep.jsx